import { Box, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material";
import { SvgIcon } from "@mui/material";
import { ReactComponent as Comellas } from "../theme/icons/colaboradors/academia-comellas-cluet.svg";
import { ReactComponent as Tossalet } from "../theme/icons/colaboradors/el-tossalet.svg";
import { ReactComponent as Padel } from "../theme/icons/colaboradors/padel-indoor.svg";
import { ReactComponent as Ceec } from "../theme/icons/colaboradors/ceec.svg";
import { ReactComponent as Basquet } from "../theme/icons/colaboradors/basquet-berga.svg";
import { ReactComponent as Espai } from "../theme/icons/colaboradors/espai-viu.svg";
import { ReactComponent as Cpa } from "../theme/icons/colaboradors/cpa.svg";
import { ReactComponent as Trave } from "../theme/icons/colaboradors/cal-trave.svg";
import { ReactComponent as Anonima } from "../theme/icons/colaboradors/lanonima.svg";
import { ReactComponent as Peu } from "../theme/icons/colaboradors/peu-de-via.svg";
import { ReactComponent as Volei } from "../theme/icons/colaboradors/volei.svg";

const MainBox = styled(Box)(() => ({
	backgroundColor: "#e8e3c5",
	justifyContent: "center",
	alignContent: "center",
	alignItems: "center",
}));

const Colaboradors = () => {
	const colaboradors = [
		{
			logo: Comellas,
			viewBox: "0 0 75 30",
		},
		{
			logo: Padel,
			viewBox: "0 0 75 20",
		},
		{
			logo: Ceec,
			viewBox: "0 0 72 20",
		},
		{
			logo: Espai,
			viewBox: "0 0 50 35",
		},
		{
			logo: Trave,
			viewBox: "0 0 70 50",
		},
		{
			logo: Peu,
			viewBox: "0 0 350 350",
		},
		// {
		// 	logo: Volei,
		// 	viewBox: "0 0 450 620",
		// },
	];

	return (
		<MainBox px={10} pt={4}>
			<Box py={5}>
				<Typography variant="h2">Col·laboradors</Typography>
			</Box>

			<Grid container spacing={10}>
				{colaboradors.map((item) => (
					<Grid item md={2} xl={1}>
						<SvgIcon
							component={item.logo}
							viewBox={item.viewBox}
							sx={{
								width: 200,
								height: "100% !important",
							}}
						/>
					</Grid>
				))}
				<Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={
								process.env.PUBLIC_URL +
								"/images/tossalet_nou.png"
							}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 200,
							}}
							alt="Scratch barcelona"
						/>
					</Box>
				</Grid>
				<Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={process.env.PUBLIC_URL + "/images/basquet.png"}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 200,
							}}
							alt="Scratch barcelona"
						/>
					</Box>
				</Grid>
				<Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={process.env.PUBLIC_URL + "/images/scratch.png"}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 200,
							}}
							alt="Scratch barcelona"
						/>
					</Box>
				</Grid>
				<Grid item md={2} xl={1}>
					<Box mt={-1}>
						<img
							src={
								process.env.PUBLIC_URL + "/images/la-galeta.png"
							}
							style={{ width: 200 }}
							alt="La Galeta"
						/>
					</Box>
				</Grid>
				{/* <Grid item md={2} xl={1}>
					<Box mt={-5}>
						<img
							src={
								process.env.PUBLIC_URL +
								"/images/escola-btt.png"
							}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 200,
							}}
							alt="Escola BTT del Berguedà"
						/>
					</Box>
				</Grid> */}
				<Grid item md={2} xl={1}>
					<Box mt={-3}>
						<img
							src={process.env.PUBLIC_URL + "/images/ceb.png"}
							style={{
								mixBlendMode: "multiply",
								width: 160,
							}}
							alt="Club d'Escacs del Berguedà"
						/>
					</Box>
				</Grid>
				{/* <Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={
								process.env.PUBLIC_URL +
								"/images/espai-gaba.png"
							}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 190,
							}}
							alt="Club d'Escacs del Berguedà"
						/>
					</Box>
				</Grid> */}
				<Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={
								process.env.PUBLIC_URL + "/images/clubpati.png"
							}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 190,
							}}
							alt="Club Patí Berguedà"
						/>
					</Box>
				</Grid>
				<Grid item md={2} xl={1}>
					<Box mt={-4}>
						<img
							src={process.env.PUBLIC_URL + "/images/logaina.png"}
							style={{
								marginTop: 30,
								mixBlendMode: "multiply",
								width: 190,
							}}
							alt="Logaina"
						/>
					</Box>
				</Grid>
				<Grid item md={2} xl={1}>
					<Box mt={1}>
						<img
							src={
								process.env.PUBLIC_URL + "/images/munt_arts.png"
							}
							style={{ width: 230 }}
							alt="La Galeta"
						/>
					</Box>
				</Grid>

				<Grid item md={2} xl={1}>
					<Box mt={-2}>
						<img
							src={process.env.PUBLIC_URL + "/images/rugby.png"}
							style={{ width: 230 }}
							alt="La Galeta"
						/>
					</Box>
				</Grid>
			</Grid>
		</MainBox>
	);
};

export default Colaboradors;
